import styled from 'styled-components';

import { media } from 'utils/detection';
import withParallax from 'utils/parallax';

export default styled(withParallax(styled.a`
  color: ${props => props.theme.textSemiDark};
  font-family: 'Galano Classic';
  font-size: 12px;
  font-weight: 500;
  margin: 0;
  padding: 0;
  text-decoration: none;
  
  ${media.medium`
    font-size: 13px;
  `}
`))`
  display: inline-block;
`;
